import { Text } from "@chakra-ui/react";
import { TenantDetalhe } from "features/tenants/typings/tenant";
import {
  Control,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from "react-hook-form";
import DadosGeraisEmpresa from "components/Features/Empresa/FormEmpresa/DadosGerais";

function DadosGerais({
  control,
  setField,
  watch,
  trigger,
  isEdit,
  forceEditDocument,
  form,
}: {
  control: Control<TenantDetalhe, object>;
  setField: UseFormSetValue<TenantDetalhe>;
  trigger: UseFormTrigger<TenantDetalhe>;
  watch: UseFormWatch<any>;
  isEdit?: boolean;
  forceEditDocument?: boolean;
  form?: TenantDetalhe;
}) {
  return (
    <>
      <Text mb="16px" fontSize="18px">
        Dados Cadastrais
      </Text>

      <DadosGeraisEmpresa
        forceEditDocument={forceEditDocument}
        watch={watch}
        control={control as any}
        setField={setField as any}
        hideFieldsBeforeSearchCNPJ
        isCondominio
        form={form}
        isEdit={isEdit}
        onLoadedCnpj={() => {
          trigger();
        }}
      />
    </>
  );
}

export default DadosGerais;
